import { UUID } from "io-ts-types/lib/UUID"
import { platform, createRequest } from "@shared/platform-api/requests"
import { createRequestHook } from "../../../../api/createRequestHook"
import { User, createPolicyModern } from "./details"
import { Policy } from "./types"

type Input = Readonly<{ id: UUID; user: User }>
type Output = Policy

const findPolicy = createRequest<Input, Output>(async (input, getToken) => {
  const api = platform(getToken)

  const policy = await api.policies.findPolicy({ id: input.id })
  const stats = await api.fleets.fleetStats({ id: input.id })

  return createPolicyModern(policy, input.user, stats)
})

export const useFindPolicy = createRequestHook(findPolicy)
